import { render, staticRenderFns } from "./GroupEditorControl.vue?vue&type=template&id=374f94f3&scoped=true"
import script from "./GroupEditorControl.vue?vue&type=script&lang=js"
export * from "./GroupEditorControl.vue?vue&type=script&lang=js"
import style0 from "./GroupEditorControl.vue?vue&type=style&index=0&id=374f94f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374f94f3",
  null
  
)

export default component.exports